<template>
  <div class="product-images-wrapper">
    <div class="zoom-parent">
      <div class="video-show" v-if="videoUrl && isVideoActive === 1 && (currImage === videoIndex - 1 || videoIndex === 0)"
      >
        <VideoPlayer
          :src="videoUrl" 
          :poster="getActiveImage"
          :playVideo="playVideo"
        />
      </div>
      <div v-else class="productZoomer">
        <img :src="getActiveImage" :class="[{ 'show-blur': isBlur }]" @click="callMagnify(getActiveImage)" /> 
      </div>
    </div>
    <div class="img-list-wrap d-flex flex-row">
      <carousel ref="my-carousel"
        :paginationEnabled="false" navigationNextLabel=" " navigationPrevLabel=" "
        :autoplay="false" :paginationPadding="7" class="bannerview"
        :perPageCustom="[[480, 2], [768, 4], [1200, 5], [1920, 6]]"
        :perPage="3.2"
        :navigateTo="navShown ? getcurrPage : 0"
      >
        <slide v-for="(prm, index) in getImageArray" :key="index">
          <div class="card-container pointer'">
            <img class="img-card"
              :data-src="prm"
              @click="switchImage(index)"
            />
            <div class="overlay" v-if="videoUrl && isVideoActive === 1 && (index === videoIndex-1 || videoIndex ===0)" @click="switchImage(index)">
              <img src="https://tss-static-images.gumlet.io/media/play.png"
              :class="[{ 'show-blur': isBlur }]"
                style="height:20px;"
              />
            </div>
          </div>
        </slide>
      </carousel>
    </div>
  </div>
</template>
<script>
  import {Carousel, Slide} from 'vue-carousel'
  import VideoPlayer from './VideoPlayer.vue'
  import device from 'vue-device-detector-js'
  import Vue from 'vue'
  Vue.use(device)
  export default {
    props: ['imgArray', 'activeImg', 'videoUrl', 'isVideoActive', 'videoIndex', 'isBlur'],
    data () {
      return {
        prodImgPath: process.env.IMG_BASE_URL + process.env.PRODUCT_DETAIL_IMG,
        currImage: 0,
        navShown: false,
        playVideo: true
      }
    },
    components: {
      Carousel,
      Slide,
      VideoPlayer
    },
    methods: {
      switchImage (index) {
        this.currImage = index
      },
      callMagnify (img) {
        this.$parent.magnify(img, this.currImage)
      }
    },
    computed: {
      getActiveImage () {
        return this.prodImgPath + this.imgArray[this.currImage]
      },
      getImageArray () {
        return this.imgArray && this.imgArray.map((img) => {
          return this.prodImgPath + img
        })
      },
      getcurrPage () {
        return parseInt(this.currImage / 4)
      }
    },
    mounted () {
      this.currImage = this.activeImg
      setTimeout(() => {
        this.navShown = true
      }, 600)
    }
  }
</script>
<style scoped>
.card-container {
  padding: 2px 1px;
}
.img-card {
  width: 25vh;
  height: 100px;
  object-fit: cover;
}
.img-list-wrap::-webkit-scrollbar { width: 0 !important }
.card-container {
  position: relative;
}
.card-container .overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.show-blur {
    filter: blur(4px)
  }
</style>



// WEBPACK FOOTER //
// ProductBanner.vue?b9ba3624